import {
    _137C,
    _311C,
    Aquamarine,
    Azure,
    BlueBlue,
    ClearWhite,
    DarkPeach,
    Blue,
    Link,
    NiceBlue,
    Purple,
    PurplePink,
    ReflexBlue,
    Salmon,
    SpbSky0,
    SunflowerYellow,
    Tangerine,
    WarmPink,
    WarmRedC,
} from './palette';

/*
* -------------------------------------------
*             CHART COSTS
* -------------------------------------------
*/

export const chartCostsOneTimeCharges = Link;
export const chartCostsOtherRecurringCharges = _137C;
export const chartCostsRecurringChargesForRatePlan = Blue;
export const chartCostsStroke = ClearWhite;
export const chartCostsTrafficChargesAtHomeMacroRegionAndNotInHomeRegion = _311C;
export const chartCostsTrafficChargesAtHomeRegion = Purple;
export const chartCostsTrafficChargesAtOutHomeMacroRegion = ReflexBlue;
export const chartCostsTrafficChargesAtRoaming = WarmRedC;

/*
* -------------------------------------------
*             CHART DYNAMIC
* -------------------------------------------
*/

export const chartDynamicColorAquamarine = NiceBlue;
export const chartDynamicColorBlue = BlueBlue;
export const chartDynamicColorBlueLight = Azure;
export const chartDynamicColorGreenLight = Aquamarine;
export const chartDynamicColorOrange = Tangerine;
export const chartDynamicColorOrangeLight = DarkPeach;
export const chartDynamicColorPink = WarmPink;
export const chartDynamicColorPurpleLight = PurplePink;
export const chartDynamicColorRed = Salmon;
export const chartDynamicColorYellow = SunflowerYellow;

export const chartErrorColorSquare = `
    linear-gradient(to bottom,
        ${ClearWhite} ,
        ${SpbSky0}
    );
`;
